

import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
];

const router = new VueRouter({
  mode:'history',
  routes,
});

console.log(new VueRouter({
  mode:'history',
  routes,
}))
router.beforeEach(function (to, from, next) {
  const menus = JSON.parse(sessionStorage.getItem('menus'))
  if (menus && menus.length > 0) {
    const obj = menus.find((item) => item.path == to.fullPath)
    if (obj) {
      sessionStorage.setItem('ACTIVEITEM', JSON.stringify(obj))
    }
  }
  next()
})

export default router;
